import React from 'react'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { formatPrice } from 'helpers/utils'

/* eslint-disable react/prop-types */
const ProductPrice = ({ title, count, details: { salePrice, salePriceAvailable, price } = {}}) =>
  <React.Fragment>
    {
      (salePriceAvailable && salePrice > 0) ?
        <React.Fragment>
          <Price>Starting at: { formatPrice(salePrice) }</Price>
          <Price small old>{ formatPrice(price) }</Price>
        </React.Fragment> :
        <Price>{ formatPrice(price) }</Price>
    }
  </React.Fragment>

export default ProductPrice


const Price = styled.div`
  display: inline-block;
  vertical-align: bottom;
  margin-right: 10px;
  line-height: 22px;
  color: ${Theme.colors.sub_grey};
  ${Mixin.font.GothamBold(18)}
  ${Media.mobile`
    font-size: 16px;
    color: ${Theme.colors.black};

    &:first-child {
      display: block;
    }
  `}

  ${props => props.small && css`
    margin-right: 5px;
    color: ${Theme.colors.caption_grey};
    line-height: 18px;
    ${Mixin.font.GothamBook(14, 400)}
    ${Media.mobile`
      font-size: 12px;
      color: ${Theme.colors.caption_grey};
    `}
  `}
  ${props => props.old && css`
    line-height: 18px;
    text-decoration: line-through;
  `}
  ${props => props.new && css`
    ${Media.mobile`
      color: ${Theme.colors.dark_red};
    `}
  `}
`
